(ns hai.admin-ui.users.table
  "Users table"
  (:require
   [clojure.string :as str]
   [hai-model.model :as model]
   [hai.users.helper :refer [query]]
   [hai.ui.components.button :as button]
   [hai.ui.components.card :as card]
   [hai.ui.components.collection.filters :as filters]
   [hai.ui.components.collection.form :as col.form]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.ui.components.collection.views.table :as table]
   [hai.ui.components.form.select.single-select :as single-select]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.web-app.layout :as layout]))

(defn table
  []
  [collection/component
   {:id ::table
    :update-mutation 'user/update
    :schema model/User
    :query [{:users/table [{:collection/items (conj query :user/signup-pathway)}]}]
    :paginate? true
    :no-items (fn [_] [:em "No users found"])
    ;; TODO default card render
    :card (fn [collection item]
            [card/card
             [cards/card-select-checkbox collection item]
             [cards/column-render collection item]])
    :columns (cond->
              [{:header "Emails"
                :attr   :user/email
                :filter (filters/text-search {:placeholder "Email..."})
                 ;; TODO disabled until we address the semantics of changing emails
                 ;; :field (fn [email]
                 ;;          [form/collection* form/input email])
                :render (fn [{:user/keys [email] :as user}]
                          [table/title-render
                           {:title    (str/join ", " email)
                            :on-click (fn [_] (>e [:routing/navigate [:users/edit user]]))}])}
               {:header "Full Name"
                :attr   :user/full-name
                :filter (filters/text-search {:placeholder "Full Name..."})
                :field  col.form/input}
               {:header "Signup"
                :attr   :user/signup-pathway
                :render (fn [{:user/keys [signup-pathway]}]
                          [table/table-cell (subs (str signup-pathway) 1)])
                :filter {:schema      :keyword
                         :type        :filter.remote/select
                         :placeholder "Pathway..."
                         :field       single-select/field}}]
               @(<s :auth/admin?)
               (conj
                {:header "Admin"
                 :render (fn [{:user/keys [uuid]}]
                           [table/table-cell
                            [button/outline-button {:on-click (fn [_] (>e [:auth/impersonate uuid]))}
                             "Impersonate"]])}))}])

(defn page
  [_]
  [layout/page
   [layout/breadcrumbs]
   [layout/heading]
   [layout/lead*
    [layout/lead
     [:span
      [:strong "Manage who has access and how they use Humble"]
      [:br]
      "Add teammates, assign roles, and group users by team, department, or access level. Keep everything structured and visible as you scale."]]]
   [layout/content
    [table]]])
